import Onboarding2 from "../../components/Onboarding2";

export default function OnboardingPage2() {
    return (
        <Onboarding2 />
    )
};